import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalVariableService } from '../../../../../core/services/global-variable.service';
import { AppService } from '../../../../../core/services/app.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FicheOfa } from 'src/app/core/model/fiche';
import { EventEmitterService } from '../../../../../core/services/event-emitter.service';
import { ToastrService } from 'ngx-toastr';
import { SharedDataService } from '../../../../../core/services/shared-data.service';
import { LocalStorageService } from 'ngx-webstorage';
import { HttpClient } from '@angular/common/http';
import swal from "sweetalert2";
import {AppConfigService} from "../../../../../core/services/config.service";

@Component({
  selector: 'app-details-ofa',
  templateUrl: './details-ofa.component.html',
  styleUrls: ['./details-ofa.component.css']
})

export class DetailsOfaComponent implements OnInit {
  config = {
    // value: false,
    name: "",
    // disabled: false,
    height: 35,
    width: 90,
    margin: 3,
    fontSize: 8,
    speed: 300,
    color: {
      checked: "red",
      unchecked: "#56C128"
    },
    switchColor: {
      checked: "#fff",
      unchecked: "fff"
    },
    labels: {
      unchecked: "FICHE OK",
      checked: "RETOURNEE"
    },
    checkedLabel: "",
    uncheckedLabel: "",
    fontColor: {
      checked: "#fafafa",
      unchecked: "#fff"
    }
  };
  @Input() ofa;
  @Input() vue;
  @Input() type;
  @Input() test;
  @Input() idDir;
  Arr = Array;
  public show: boolean = false;
  public name: string;
  public matricule: string;
  public filterofa: string;
  public bonusPriorite: boolean = false;
  public listCategorie: any = [];
  public listDirecteur: any = [];
  public num: number;
  public user: any;
  public taux_gratification: number = 0;
  public classification: any;
  public categorie: any;
  public anciennete_cat: any;
  public anciennete_sir: any;
  public age: any;
  public salaire_brut: any;
  public salaire_net: any;
  public anciennete_poste: any;
  public note_eia: any;
  public appreciation_eia: any;
  public statut_eia: any;
  public cas_rh: any;
  public indicateur_rh: any;
  public salaire_brut_remake: any;
  public calcSalaire: any;
  public salaireBis: any;
  public salaire_final: any;
  public salaire_parse: any;
  public commentaire: any;
  public commentaireArbitrage: any;
  public response: any;
  public listMyOfa: any = [];
  public idStructure = 0;
  public listCampagne: any;
  public listCampagneOfa: any;
  public dataLoaded: boolean = false;
  public PORTAIL_NAME: string;
  public API_URL: any;
  public ENVIRONNEMENT: any;
  public FILE_URL: string;
  public ficheOfaByCampagne: any;
  public direction_id: any;
  public visualiser: any;
  public photo_courbe_salaire: string;
  public settingsTaux = {};
  public listTaux = [];
  public taux_grat_selected: any;
  public grafanaLink: string;
  public grafanaLinkAnalyse: string;
  public nameUserConnected: string;

  dernierOfaData: DernierOfa = new DernierOfa(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
  ofaData: FicheOfa = new FicheOfa(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
  constructor(
    private activeModal: NgbActiveModal,
    private variable: GlobalVariableService,
    private configService: AppConfigService,
    private toastrService: ToastrService,
    private _service: AppService,
    private _loader: LoadingBarService,
    private storage: LocalStorageService,
    private sharedService: SharedDataService) {
    this.API_URL = configService.get('HOST_API_ONLINE');
    this.ENVIRONNEMENT = configService.get('HOST_ENVIRONMENT');
    this.FILE_URL = this.configService.get('FILE_URL');
  }

  ngOnInit() {
    this.user = JSON.parse(this.variable.getUser());
    this.grafanaLink = `${this.ofa?.lien_dashboard}&var-categorie=${this.ofa?.categorie}&var-matricule=${this.ofa?.matricule}`;
    this.grafanaLinkAnalyse = `${this.user?.lien_analyse}${this.ofa?.matricule}`;
    this.direction_id = this.idDir;

    this.visualiser = this.test;

    this.name = this.ofa.nom;

    this.nameUserConnected = this.ofa?.nom + ' ' + this.ofa?.prenoms;

    this.matricule = this.ofa.matricule;
    this.ofa.classification ? this.classification = this.ofa.classification : this.classification = 'N/A';
    this.ofa.categorie ? this.categorie = this.ofa.categorie : this.categorie = 'N/A';

    this.ofa.anciennete_cat ? this.anciennete_cat = this.ofa.anciennete_cat : this.anciennete_cat = 'N/A';
    this.ofa.anciennete_sir ? this.anciennete_sir = this.ofa.anciennete_sir : this.anciennete_sir = 'N/A';
    this.ofa.age ? this.age = this.ofa.age : this.age = 'N/A';
    this.ofa.salaire_brut ? this.salaire_brut = this.thousandSeparator(this.ofa.salaire_brut) : this.salaire_brut = 'N/A';
    this.ofa.salaire_net ? this.salaire_net = this.thousandSeparator(this.ofa.salaire_net) : this.salaire_net = 'N/A';
    this.ofa.anciennete_poste ? this.anciennete_poste = this.ofa.anciennete_poste : this.anciennete_poste = 'N/A';
    this.ofa.note_eia ? this.note_eia = this.ofa.note_eia : this.note_eia = 'N/A';
    this.ofa.appreciation_eia ? this.appreciation_eia = this.ofa.appreciation_eia : this.appreciation_eia = 'N/A';
    this.ofa.statut_eia ? this.statut_eia = this.ofa.statut_eia : this.statut_eia = 'N/A';

    this.ofa.cas_rh ? this.cas_rh = this.ofa.cas_rh : this.cas_rh = 'N/A';
    this.ofa.indicateur ? this.indicateur_rh = this.ofa.indicateur : this.indicateur_rh = 'N/A';
    this.ofaData.promo_priorite = this.ofa.promo_priorite;
    this.categorie = this.ofa.promo_categorie_id;
    this.ofaData.promo_categorie_id = this.categorie;
    this.ofaData.aug_priorite = this.ofa.aug_priorite;
    this.ofaData.gratif_priorite = this.ofa.gratif_priorite;
    this.ofaData.bonus_priorite = this.ofa.bonus_priorite;
    this.ofaData.promo_commentaire = this.ofa.promo_commentaire;
    this.ofaData.aug_commentaire = this.ofa.aug_commentaire;
    this.ofaData.aug_montant = this.ofa.aug_montant;
    this.ofaData.gratif_taux = this.ofa.gratif_taux;
    this.ofaData.gratif_commentaire = this.ofa.gratif_commentaire;
    this.ofaData.bonus_commentaire = this.ofa.bonus_commentaire;
    this.ofaData.commentaire = this.ofa.commentaire_gec;
    this.ofaData.commentaireArbitrage = this.ofa.commentaire_conseil;
    this.ofaData.commentaire_retourne = this.ofa.commentaire_retourne;
    this.ofaData.bonus_montant = this.ofa?.bonus_montant;
    this.ofaData.check_switch = !!+this.ofa.a_revoir;
    this.dernierOfaData.anneeid = 1;

    this.filterOfa('proposition');
    this.getCategorie();
    let resultSalaire = this.ofa.salaire_brut.toString()
    let salaire = resultSalaire.split('FCFA');
    let salaire_split = salaire[0].toString();
    let salaire_brut_whithout_space = salaire_split.split(' ');
    this.salaire_brut_remake = salaire_brut_whithout_space[0] + '' + salaire_brut_whithout_space[1];
    this.calcSalaire = this.ofa.salaire_brut * (this.ofaData.gratif_taux / 100);
    this.salaireBis = this.calcSalaire.toFixed(0);
    this.salaire_parse = parseInt(this.salaireBis.replace(/\D/g, ""));
    this.salaire_final = /* this.salaire_parse.toLocaleString('fr-FR'); */ this.thousandSeparator(this.salaireBis)
    this.photo_courbe_salaire = `${this.FILE_URL}${this.ofa.lien_courbe_salaire}`
    this.settingsTaux = {
      labelKey: 'taux',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      singleSelection: true,
      searchBy: ['taux'],
      enableCheckAll: false,
      classes: 'myclass custom-class',
      showCheckbox: false,
      noDataLabel: 'Taux vide'
    };
    this.listTaux = [
      { 'id': 75, 'taux': "75" },
      { 'id': 80, 'taux': "80" },
      { 'id': 85, 'taux': "85" },
      { 'id': 90, 'taux': "90" },
      { 'id': 95, 'taux': "95" },
      { 'id': 100, 'taux': "100" },
      { 'id': 105, 'taux': "105" },
      { 'id': 110, 'taux': "110" },
      { 'id': 115, 'taux': "115" },
      { 'id': 120, 'taux': "120" },
      { 'id': 125, 'taux': "125" }
    ];;
    this.taux_grat_selected = [
      { 'id': this.ofa.gratif_taux, 'taux': this.ofa.gratif_taux ? this.ofa.gratif_taux : 0 + "%" },
    ]
  }

  public getUserInitials(fullName: string): string {
    if (!fullName) return '';

    const nameParts = fullName.split(' ');
    const initials = nameParts.length > 1
      ? nameParts[0][0] + nameParts[1][0]
      : nameParts[0][0];

    return initials.toUpperCase();
  }

  public quitterFiche() {
    swal
      .fire({
        title: 'Êtes-vous sûr de quitter?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#FD7E14',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Oui, je confirme',
      })
      .then((result) => {
        if (result.value) {
          this.closeModal();
        }
      });
  }

  public thousandSeparator(value) {
    const spaces = value => String(value)
      .replace(
        /(?!^)(?=(?:\d{3})+$)/g,
        ' '
      );
    return value != null ? spaces(value) : '--';
  }

  onChangeItem(event: any) {
    this.getDernierOfa(event.value.id)
  }

  public onItemSelect(item) {
    this.ofaData.gratif_taux = item.id;
    this.calcSalaire = this.ofa.salaire_brut * (this.ofaData.gratif_taux / 100);
    this.salaireBis = this.calcSalaire.toFixed(0);
    this.salaire_parse = parseInt(this.salaireBis.replace(/\D/g, ""));
    this.salaire_final = this.salaire_parse.toLocaleString('fr-FR');
  }

  public onDeSelectAll(item, type) {
    this.ofaData.gratif_taux = '';
  }

  //Get dernier ofa
  public getDernierOfa(id) {
    const data = {
      annee_id: id,
      matricule: this.ofa?.matricule
    }
    this._service.postData(`gestion-ofas/historique-ofas/getFicheOfaByCampagne`, data)
      .subscribe(res => {
        if (res.error === false) {
          this.ficheOfaByCampagne = res.data;
          this.getModelDernierOfa()
          this._loader.stop();
          this.toastrService.success(res.message);
        } else {
          swal.fire({
            title: 'HR PERF',
            text: res.message,
            type: 'error',
            confirmButtonColor: '#FD7E14',
            confirmButtonText: 'Ok'
          });
        }
      }, err => {
        swal.fire({
          title: 'HR PERF',
          text: JSON.stringify(err.error.message),
          type: 'error',
          confirmButtonColor: '#FD7E14',
          confirmButtonText: 'Ok'
        });
      });
  }

  onDropdownClick() {
    if (!this.dataLoaded) {
      this._service.getData('gestion-ofas/annee-historique-ofa/all')
        .subscribe((res) => {
          this.listCampagneOfa = res['data'];
          this.dataLoaded = true;
        }
        );
    }
  }


  public getModelDernierOfa() {
    this.dernierOfaData.classification = this.ficheOfaByCampagne.classification;
    this.dernierOfaData.categorie = this.ficheOfaByCampagne.categorie;
    this.dernierOfaData.anciennete_cat = this.ficheOfaByCampagne.anciennete_cat;
    this.dernierOfaData.anciennete_sir = this.ficheOfaByCampagne.anciennete_sir;
    this.dernierOfaData.age = this.ficheOfaByCampagne.age;
    this.dernierOfaData.salaire_brut = this.thousandSeparator(this.ficheOfaByCampagne.salaire_brut);
    this.dernierOfaData.salaire_net = this.thousandSeparator(this.ficheOfaByCampagne.salaire_net);
    this.dernierOfaData.anciennete_poste = this.ficheOfaByCampagne.anciennete_poste;
    this.dernierOfaData.note_eia = this.ficheOfaByCampagne.note_eia;
    this.dernierOfaData.appreciation_eia = this.ficheOfaByCampagne.appreciation_eia;
    this.dernierOfaData.statut_eia = this.ficheOfaByCampagne.statut_eia;
    this.dernierOfaData.cas_rh = this.ficheOfaByCampagne.cas_rh;
    this.dernierOfaData.indicateur_rh = this.ficheOfaByCampagne.indicateur_rh;
    this.dernierOfaData.bonus_montant = this.ficheOfaByCampagne.bonus_montant;
    this.dernierOfaData.gratif_montant = this.ficheOfaByCampagne.gratif_montant;
    this.dernierOfaData.aug_montant = this.ficheOfaByCampagne.aug_montant;
    this.dernierOfaData.promo_categorie = this.ficheOfaByCampagne.promo_categorie;
    this.dernierOfaData.gratif_taux = this.ficheOfaByCampagne.gratif_taux;
    this.dernierOfaData.date_aug_mont = this.ficheOfaByCampagne.date_aug_mont;
    this.dernierOfaData.date_bonus_montant = this.ficheOfaByCampagne.date_bonus_montant;
    this.dernierOfaData.date_gratif_taux = this.ficheOfaByCampagne.date_gratif_taux;
    this.dernierOfaData.date_promo_categorie = this.ficheOfaByCampagne.date_promo_categorie;
    this.dernierOfaData.commentaire_arbitrage = this.ficheOfaByCampagne.commentaire_arbitrage;
    this.dernierOfaData.commentaire_conseil = this.ficheOfaByCampagne.commentaire_conseil;
    this.dernierOfaData.commentaire_gec = this.ficheOfaByCampagne.commentaire_gec;
  }

  public filterOfa(status) {
    this.filterofa = status;
  }

  public closeModal() {
    this.activeModal.close();
  }

  public keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  public resetField(type) {
    if (type === 'promotion') {
      this.ofaData.promo_priorite = null;
    } else if (type === 'augmentation') {
      this.ofaData.aug_priorite = null;
    } else if (type === 'gratification') {
      this.ofaData.gratif_priorite = null;
    } else {
      this.ofaData.bonus_priorite = null;
    }
  }


  public onSelectCategorie(value: string) {
    this.ofaData.promo_categorie_id = value === 'null' ? null : value;
  }

  public soumettreFiche() {
    this._loader.start();
    const data = {
      'fiche_ofa_id': this.ofa.id,
      'promo_categorie_id': this.ofaData.promo_categorie_id,
      'promo_priorite': this.ofaData.promo_priorite,
      'promo_commentaire': this.ofaData.promo_commentaire,
      'aug_montant': parseInt(this.ofaData.aug_montant),
      'aug_priorite': this.ofaData.aug_priorite,
      'aug_commentaire': this.ofaData.aug_commentaire,
      'gratif_taux': parseInt(this.ofaData.gratif_taux),
      'gratif_priorite': this.ofaData.gratif_priorite,
      'gratif_commentaire': this.ofaData.gratif_commentaire,
      'bonus_montant': parseInt(this.ofaData.bonus_montant),
      'bonus_priorite': this.ofaData.bonus_priorite,
      'bonus_commentaire': this.ofaData.bonus_commentaire
    }
    this._service.postData('gestion-ofas/responsable-ofas/soumettre-proposition', data)
      .subscribe(
        res => {
          if (res.error === false) {
            this._loader.stop();
            this.activeModal.close();
            this.toastrService.success(res.message);
            this.sharedService.sendRefreshTableSoldes(); /* ICI */
            this.sharedService.sendRefreshTablePropositions();
            this.sharedService.sendRefreshTableArbitrage();
            this.sharedService.sendRefreshTableSoldesProp();
          } else {
            this._loader.stop();
            swal.fire({
              customClass: {
                container: 'my-swal'
              },
              title: 'HR PERF',
              text: res.message,
              type: 'error',
              confirmButtonColor: '#FD7E14',
              confirmButtonText: 'Ok'
            });
          }
        }, err => {
          this._loader.stop();
          swal.fire({
            title: 'HR PERF',
            text: JSON.stringify(err.error.message),
            type: 'error',
            confirmButtonColor: '#FD7E14',
            confirmButtonText: 'Ok'
          });
        }
      );
  }

  public traiterFicheGec() {
    this._loader.start();
    const data = {
      'fiche_ofa_id': this.ofa.id,
      'promo_categorie_id': this.ofaData.promo_categorie_id,
      'promo_priorite': this.ofaData.promo_priorite,
      'promo_commentaire': this.ofaData.promo_commentaire,
      'aug_montant': parseInt(this.ofaData.aug_montant),
      'aug_priorite': this.ofaData.aug_priorite,
      'aug_commentaire': this.ofaData.aug_commentaire,
      'gratif_taux': parseInt(this.ofaData.gratif_taux),
      'gratif_priorite': this.ofaData.gratif_priorite,
      'gratif_commentaire': this.ofaData.gratif_commentaire,
      'bonus_montant': parseInt(this.ofaData.bonus_montant),
      'bonus_priorite': this.ofaData.bonus_priorite,
      'bonus_commentaire': this.ofaData.bonus_commentaire
    }
    this._service.postData('campagne/ofa/traiter_fiche', data)
      .subscribe(
        res => {
          if (res.error === false) {
            this._loader.stop();
            this.activeModal.close();
            this.toastrService.success(res.message);
            this.sharedService.sendRefreshTablePropositions();
            this.sharedService.sendRefreshTableSoldes();
            this.sharedService.sendRefreshTableSoldesAnalyse();
            this.sharedService.sendRefreshTableSoldesArbitrage();

          } else {
            this._loader.stop();
            swal.fire({
              customClass: {
                container: 'my-swal'
              },
              title: 'HR PERF',
              text: res.message,
              type: 'error',
              confirmButtonColor: '#FD7E14',
              confirmButtonText: 'Ok'
            });
          }
        }, err => {
          this._loader.stop();
          swal.fire({
            title: 'HR PERF',
            text: JSON.stringify(err.error.message),
            type: 'error',
            confirmButtonColor: '#FD7E14',
            confirmButtonText: 'Ok'
          });
        }
      );
  }

  public arbitrerFiche() {
    this._loader.start();
    const data = {
      'fiche_ofa_id': this.ofa.id,
      'promo_categorie_id': this.ofaData.promo_categorie_id,
      'promo_priorite': this.ofaData.promo_priorite,
      'promo_commentaire': this.ofaData.promo_commentaire,
      'aug_montant': parseInt(this.ofaData.aug_montant),
      'aug_priorite': this.ofaData.aug_priorite,
      'aug_commentaire': this.ofaData.aug_commentaire,
      'gratif_taux': parseInt(this.ofaData.gratif_taux),
      'gratif_priorite': this.ofaData.gratif_priorite,
      'gratif_commentaire': this.ofaData.gratif_commentaire,
      'bonus_montant': parseInt(this.ofaData.bonus_montant),
      'bonus_priorite': this.ofaData.bonus_priorite,
      'bonus_commentaire': this.ofaData.bonus_commentaire,
      'commentaire_conseil': this.ofaData.commentaireArbitrage
    }
    this._service.postData('gestion-ofas/conseil-direction/soumettre-proposition-conseil', data)
      .subscribe(
        res => {
          if (res.error === false) {
            this._loader.stop();
            this.activeModal.close();
            this.toastrService.success(res.message);
            this.sharedService.sendRefreshTableSoldes(); /* ICI */
            this.sharedService.sendRefreshTableArbitrage();
            this.sharedService.sendRefreshTableSoldesArbitrage();
          } else {
            this._loader.stop();
            swal.fire({
              customClass: {
                container: 'my-swal'
              },
              title: 'HR PERF',
              text: res.message,
              type: 'error',
              confirmButtonColor: '#FD7E14',
              confirmButtonText: 'Ok'
            });
          }
        }, err => {
          this._loader.stop();
          swal.fire({
            title: 'HR PERF',
            text: JSON.stringify(err.error.message),
            type: 'error',
            confirmButtonColor: '#FD7E14',
            confirmButtonText: 'Ok'
          });
        }
      );
  }

  public arbitrerFicheDirecteur() {
    this._loader.start();
    const data = {
      'fiche_ofa_id': this.ofa.id,
      'promo_categorie_id': this.ofaData.promo_categorie_id,
      'promo_priorite': this.ofaData.promo_priorite,
      'promo_commentaire': this.ofaData.promo_commentaire,
      'aug_montant': parseInt(this.ofaData.aug_montant),
      'aug_priorite': this.ofaData.aug_priorite,
      'aug_commentaire': this.ofaData.aug_commentaire,
      'gratif_taux': parseInt(this.ofaData.gratif_taux),
      'gratif_priorite': this.ofaData.gratif_priorite,
      'gratif_commentaire': this.ofaData.gratif_commentaire,
      'bonus_montant': parseInt(this.ofaData.bonus_montant),
      'bonus_priorite': this.ofaData.bonus_priorite,
      'bonus_commentaire': this.ofaData.bonus_commentaire,
      'commentaire_retourne': this.ofaData.commentaire_retourne,
    }
    this._service.postData('gestion-ofas/directeurs/soumettre-proposition-arbitrage', data)
      .subscribe(
        res => {
          if (res.error === false) {
            this._loader.stop();
            this.activeModal.close();
            this.toastrService.success(res.message);
            this.sharedService.sendRefreshTableSoldes(); /* ICI */
            this.sharedService.sendRefreshTableArbitrage();
            this.sharedService.sendRefreshTableSoldesArbitrage();
          } else {
            this._loader.stop();
            swal.fire({
              title: 'HR PERF',
              text: res.message,
              type: 'error',
              confirmButtonColor: '#FD7E14',
              confirmButtonText: 'Ok'
            });
          }
        }, err => {
          this._loader.stop();
          swal.fire({
            title: 'HR PERF',
            text: err.error.message,
            type: 'error',
            confirmButtonColor: '#FD7E14',
            confirmButtonText: 'Ok'
          });
        }
      );
  }

  public analyserFicheOfa() {
    this._loader.start();
    const data = {
      'fiche_ofa_id': this.ofa.id,
      'direction_id': this.direction_id,
      'commentaire_gec': this.ofaData.commentaire,
      'a_revoir': this.ofaData.check_switch,
      'campagne_ofa_id': this.storage.retrieve('idCampagneOfaSelected'),
    }
    this._service.postData('gestion-ofas/analyse-suivi/soumettre-analyse', data)
      .subscribe(
        res => {
          if (res.error === false) {
            this._loader.stop();
            this.activeModal.close();
            this.sharedService.sendRefreshTableAnalyse();
            this.sharedService.sendRefreshTableSoldesAnalyse();
            this.toastrService.success(res.message);
          } else {
            this._loader.stop();
            swal.fire({
              title: 'HR PERF',
              text: res.message,
              type: 'error',
              confirmButtonColor: '#FD7E14',
              confirmButtonText: 'Ok'
            });
          }
        }, err => {
          this._loader.stop();
          swal.fire({
            title: 'HR PERF',
            text: JSON.stringify(err.error.message),
            type: 'error',
            confirmButtonColor: '#FD7E14',
            confirmButtonText: 'Ok'
          });
        }
      );
  }

  public getCategorie() {
    // this._loader.start();
    let url;
    this.vue === 'arbitrage-directeur' ? url = 'categories-superieur-conseil-direction' : url = 'categories-superieur';
    this._service.getData(`capital-humain/categories/${this.ofa.categorie}/${url}`)
      .subscribe(
        (res) => {
          if (res.error === false) {
            this._loader.stop();
            this.listCategorie = res.data;
          } else {
            this._loader.stop();
            this.activeModal.close();
            swal.fire({
              title: 'HR PERF',
              text: res.message,
              type: 'error',
              confirmButtonColor: '#FD7E14',
              confirmButtonText: 'Ok'
            });
          }
        }, err => {
          this._loader.stop();
          this.activeModal.close();
          swal.fire({
            title: 'HR PERF',
            text: JSON.stringify(err.error.message),
            type: 'error',
            confirmButtonColor: '#FD7E14',
            confirmButtonText: 'Ok'
          });
        }
      );
  }

}

export class FicheOfaCampagne {
  salaire_net: string;
  salaire_brut: string;
  agent: Agents;
  constructor(salaire_net: string, salaire_brut: string, agent: Agents,) {
    this.salaire_net = salaire_net
    this.salaire_brut = salaire_brut
    this.agent = agent
  }
}

export class Agents {
  nom: string;
  prenoms: string;
  qualite: string;
  matricule: string;
  constructor(nom: string, prenoms: string, qualite: string, matricule: string) {
    this.prenoms = prenoms;
    this.nom = nom;
    this.qualite = qualite
    this.matricule = matricule
  }
}

export class DernierOfa {
  anneeid: number;
  classification: any;
  categorie: any;
  anciennete_cat: any;
  anciennete_sir: any;
  age: any;
  salaire_brut: any;
  salaire_net: any;
  anciennete_poste: any;
  note_eia: any;
  appreciation_eia: any;
  statut_eia: any;
  cas_rh: any;
  commentaire_arbitrage: any;
  commentaire_gec: any;
  commentaire_conseil: any;
  indicateur_rh: any;
  bonus_montant: any;
  gratif_montant: any;
  aug_montant: any;
  promo_categorie: any;
  gratif_taux: any;
  date_aug_mont: any;
  date_bonus_montant: any;
  date_gratif_taux: any;
  date_promo_categorie: any;
  constructor(
    anneeid: number,
    classification: any,
    categorie: any,
    anciennete_cat: any,
    anciennete_sir: any,
    age: any,
    salaire_brut: any,
    salaire_net: any,
    anciennete_poste: any,
    note_eia: any,
    appreciation_eia: any,
    statut_eia: any,
    cas_rh: any,
    commentaire_arbitrage: any,
    commentaire_gec: any,
    commentaire_conseil: any,
    bonus_montant: any,
    gratif_montant: any,
    aug_montant: any,
    promo_categorie: any,
    gratif_taux: any,
    date_aug_mont: any,
    date_bonus_montant: any,
    date_gratif_taux: any,
    date_promo_categorie: any,
    indicateur_rh: any) {
    this.anneeid = anneeid;
    this.classification = classification
    this.categorie = categorie
    this.anciennete_cat = anciennete_cat
    this.anciennete_sir = anciennete_sir
    this.age = age
    this.salaire_brut = salaire_brut
    this.salaire_net = salaire_net
    this.anciennete_poste = anciennete_poste
    this.note_eia = note_eia
    this.appreciation_eia = appreciation_eia
    this.statut_eia = statut_eia
    this.cas_rh = cas_rh
    this.commentaire_arbitrage = commentaire_arbitrage
    this.commentaire_gec = commentaire_gec
    this.commentaire_conseil = commentaire_conseil
    this.indicateur_rh = indicateur_rh
    this.bonus_montant = bonus_montant
    this.aug_montant = aug_montant
    this.gratif_montant = gratif_montant
    this.promo_categorie = promo_categorie
    this.gratif_taux = gratif_taux
    this.date_aug_mont = date_aug_mont
    this.date_bonus_montant = date_bonus_montant
    this.date_gratif_taux = date_gratif_taux
    this.date_promo_categorie = date_promo_categorie
  }
}
